/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoJsonMultiPolygon
 */
export interface GeoJsonMultiPolygon {
    /**
     * MultiPolygon geometry type
     * @type {string}
     * @memberof GeoJsonMultiPolygon
     */
    type: GeoJsonMultiPolygonTypeEnum;
    /**
     * MultiPolygon coordinates array of Polygon coordinate arrays
     * @type {Array<Array<Array<Array<number>>>>}
     * @memberof GeoJsonMultiPolygon
     */
    coordinates: Array<Array<Array<Array<number>>>>;
}


/**
 * @export
 */
export const GeoJsonMultiPolygonTypeEnum = {
    MultiPolygon: 'MultiPolygon'
} as const;
export type GeoJsonMultiPolygonTypeEnum = typeof GeoJsonMultiPolygonTypeEnum[keyof typeof GeoJsonMultiPolygonTypeEnum];


/**
 * Check if a given object implements the GeoJsonMultiPolygon interface.
 */
export function instanceOfGeoJsonMultiPolygon(value: object): value is GeoJsonMultiPolygon {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function GeoJsonMultiPolygonFromJSON(json: any): GeoJsonMultiPolygon {
    return GeoJsonMultiPolygonFromJSONTyped(json, false);
}

export function GeoJsonMultiPolygonFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJsonMultiPolygon {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function GeoJsonMultiPolygonToJSON(json: any): GeoJsonMultiPolygon {
    return GeoJsonMultiPolygonToJSONTyped(json, false);
}

export function GeoJsonMultiPolygonToJSONTyped(value?: GeoJsonMultiPolygon | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

